import { useSearchParams } from "react-router-dom";
import KakaoOAuthCallback from "./KakaoOAuthCallback";
import { PATH } from "routes/paths";
import { parseReferralState } from "api/referralApi";

// 프로모션(웹퍼널) 전용 카카오 콜백 — /promotion/oauth/kakao
// 제휴는 /referral/oauth/kakao 로 분리되어 있으므로 이 경로에는 제휴가 오지 않는다.
//
// 단, 콜백 경로 분리 이전 번들에서 시작된 제휴 로그인은 state="referral:<코드>" 를
// 달고 이 경로로 돌아온다. 배포 시점에 OAuth 왕복 중이던 유저가 프로모션 퍼널로
// 잘못 떨어지지 않도록 한시적으로 받아준다. 구 번들이 모두 빠진 뒤 제거할 것.
const KakaoLoginRedirectPromotion = () => {
  const [searchParams] = useSearchParams();
  const legacyReferralCode = parseReferralState(searchParams.get("state"));

  return (
    <KakaoOAuthCallback
      callbackPath={PATH.kakaoLoginRedirectPromotion}
      referralCode={legacyReferralCode}
      fallbackPath={
        legacyReferralCode
          ? `${PATH.referralLogin}?code=${encodeURIComponent(
              legacyReferralCode
            )}`
          : PATH.promotionLogin
      }
    />
  );
};

export default KakaoLoginRedirectPromotion;
